import { API_PREFIX } from "./constant";
import { Request } from "./request";

export interface GetOutpatientAuditListParams {
  current?: number;
  size?: number;
  param?: string;
  treatmentDepartmentId?: string;
  treatmentDoctorId?: string;
  treatmentTimeHead?: string;
  treatmentTimeTail?: string;
}

export function getOutpatientAuditList(
  params: GetOutpatientAuditListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/treatment/log`,
    method: "GET",
    params,
  };
}
